import CSM01customerServiceMap from '../../modules/CSM01-customer-service-map/CSM01-customer-service-map';
import set01Settlement from '../../modules/SET01-settlement/SET01-settlement.js';
import TAC01termsAndConditions from '../../modules/TAC01-terms-and-conditions/TAC01-terms-and-conditions';

import Vue from 'vue';
import {base} from './basicLayout';

document.body.addEventListener('jsLoaded', function () {
	(() => new Vue({
		el: '#vue-app',
		components: {
			'set01-settlement': set01Settlement,
			'csm01-customer-service-map': CSM01customerServiceMap,
			'tac01-terms-and-conditions': TAC01termsAndConditions
		},
		extends: base
	}))();
});



// WEBPACK FOOTER //
// ../source/build-entry/layouts/taszf.js